import RaceProgressInfoDescription from './RaceProgressInfoDescription';

export default RaceProgressInfoDescription;
